// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/Footer.scss
// module id = ./src/styles/Footer.scss
// module chunks = 0